import { ApiInstance } from '@src/services/api-instance';
import { OrgConfigCredentialsService } from './credentials/org-config-credentials';

export class OrgConfigV1Service {
  private readonly client: ApiInstance;

  public credentials: OrgConfigCredentialsService;

  constructor(client: ApiInstance) {
    this.client = client;

    this.credentials = new OrgConfigCredentialsService(this.client);
  }
}
